/* Jasjeet Singh Realty — cinematic progressive enhancement only. Site works without this file. */
(function(){
  "use strict";
  document.documentElement.classList.add('js-jr-ready');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(){
    var els = document.querySelectorAll('[data-jr-reveal]');
    if(!els.length) return;
    if(reduceMotion || !('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold:.12, rootMargin:'0px 0px -70px 0px' });
    els.forEach(function(e){ io.observe(e); });
  }

  function splitHeroTitle(hero){
    var title = hero.querySelector('.jr-hero__title');
    if(!title || title.dataset.jrSplit === 'true') return;
    var words = title.textContent.trim().split(/\s+/);
    if(words.length < 2) return;
    title.innerHTML = words.map(function(word){
      return '<span class="jr-word"><span>' + word.replace(/</g,'&lt;').replace(/>/g,'&gt;') + '</span></span>';
    }).join(' ');
    title.dataset.jrSplit = 'true';
  }

  function initHero(){
    var hero = document.querySelector('.jr-hero');
    if(!hero) return;
    splitHeroTitle(hero);
    var img = hero.querySelector('img');
    if(!img){ hero.classList.add('is-loaded'); }
    else if(img.complete){ requestAnimationFrame(function(){ hero.classList.add('is-loaded'); }); }
    else { img.addEventListener('load', function(){ hero.classList.add('is-loaded'); }, {once:true}); setTimeout(function(){hero.classList.add('is-loaded');}, 1200); }

    if(!reduceMotion && window.matchMedia('(hover:hover) and (pointer:fine)').matches){
      hero.addEventListener('mousemove', function(e){
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--jr-mouse-x', ((e.clientX-r.left)/r.width*100).toFixed(2)+'%');
        hero.style.setProperty('--jr-mouse-y', ((e.clientY-r.top)/r.height*100).toFixed(2)+'%');
      });
    }
  }

function initTestimonials(){
    var stages = document.querySelectorAll('[data-jr-testimonial-stage]');
    if(!stages.length) return;

    stages.forEach(function(stage){
      if(stage.dataset.jrBound === 'true') return;
      stage.dataset.jrBound = 'true';

      var slides = stage.querySelectorAll('.jr-testimonial-slide');
      var dots = stage.querySelectorAll('[data-jr-testimonial-dot]');
      var prev = stage.querySelector('[data-jr-testimonial-prev]');
      var next = stage.querySelector('[data-jr-testimonial-next]');
      if(slides.length < 2) return;

      var index = 0;
      function show(i){
        var safeIndex = (i + slides.length) % slides.length;
        slides.forEach(function(s,n){ s.classList.toggle('is-active', n===safeIndex); });
        dots.forEach(function(d,n){ d.classList.toggle('is-active', n===safeIndex); });
        index = safeIndex;
      }

      dots.forEach(function(dot, i){ dot.addEventListener('click', function(){ show(i); restart(); }); });
      if(prev) prev.addEventListener('click', function(){ show(index - 1); restart(); });
      if(next) next.addEventListener('click', function(){ show(index + 1); restart(); });

      var timer;
      function restart(){
        clearInterval(timer);
        if(!reduceMotion) timer = setInterval(function(){ show(index + 1); }, 6000);
      }
      restart();
    });
  }

  function initConcierge(){
    var sliders = document.querySelectorAll('[data-jr-concierge]');
    sliders.forEach(function(slider){
      if(slider.dataset.jrBound === 'true') return;
      slider.dataset.jrBound = 'true';
      var before = slider.querySelector('[data-jr-concierge-before]');
      var handle = slider.querySelector('[data-jr-concierge-handle]');
      if(!before || !handle) return;
      var dragging = false;
      function setPosition(clientX){
        var rect = slider.getBoundingClientRect();
        var x = clientX - rect.left;
        var pct = Math.min(100, Math.max(0, (x / rect.width) * 100));
        before.style.width = pct + '%';
        handle.style.left = pct + '%';
      }
      function onMove(e){
        if(!dragging) return;
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        setPosition(clientX);
      }
      slider.addEventListener('mousedown', function(e){ dragging = true; setPosition(e.clientX); });
      slider.addEventListener('touchstart', function(e){ dragging = true; setPosition(e.touches[0].clientX); }, {passive:true});
      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, {passive:true});
      document.addEventListener('mouseup', function(){ dragging = false; });
      document.addEventListener('touchend', function(){ dragging = false; });
    });
  }

  function initCountUp(){
    var stats = document.querySelectorAll('.jr-stat strong');
    if(!stats.length) return;
    function parseValue(text){
      var match = String(text).match(/^(.*?)([\d,.]+)(.*)$/);
      if(!match) return null;
      return {prefix:match[1], num:parseFloat(match[2].replace(/,/g,'')), suffix:match[3], decimals:(match[2].split('.')[1]||'').length};
    }
    function format(n, decimals){
      return n.toLocaleString(undefined,{maximumFractionDigits:decimals,minimumFractionDigits:decimals});
    }
    function animate(el){
      if(el.dataset.jrCounted === 'true') return;
      var data = parseValue(el.textContent.trim());
      if(!data || isNaN(data.num)) return;
      el.dataset.jrCounted = 'true';
      if(reduceMotion){ el.textContent = data.prefix + format(data.num,data.decimals) + data.suffix; return; }
      var start = performance.now(), duration = 1450 + Math.min(data.num,1000) * 0.25;
      function tick(now){
        var t = Math.min(1,(now-start)/duration);
        var eased = 1 - Math.pow(1-t,4);
        el.textContent = data.prefix + format(data.num*eased,data.decimals) + data.suffix;
        if(t<1) requestAnimationFrame(tick);
        else el.textContent = data.prefix + format(data.num,data.decimals) + data.suffix;
      }
      requestAnimationFrame(tick);
    }
    if(!('IntersectionObserver' in window)){ stats.forEach(animate); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if(entry.isIntersecting){ animate(entry.target); io.unobserve(entry.target); } });
    }, {threshold:.35});
    stats.forEach(function(s){ io.observe(s); });
  }

  function initStaggerIndexes(){
    var selectors = ['.jr-listing-card','.jr-service-card','.jr-neighbourhood-card','.jr-office-card','.jr-press-item','.jr-stat'];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el,i){ el.style.setProperty('--jr-i', i); });
    });
  }

  function initProgress(){
    if(document.querySelector('.jr-scroll-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'jr-scroll-progress';
    document.body.appendChild(bar);
    function update(){
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var progress = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, progress)) + ')';
    }
    update();
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
  }

function initMagneticButtons(){
    if(reduceMotion || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var items = document.querySelectorAll('.jr-btn,.button,.jr-link');
    items.forEach(function(el){
      if(el.dataset.jrMagnetic === 'true') return;
      el.dataset.jrMagnetic = 'true';
      el.classList.add('jr-magnetic');
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width/2) * .16;
        var y = (e.clientY - r.top - r.height/2) * .22;
        el.style.transform = 'translate3d('+x+'px,'+y+'px,0)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
    });
  }

  function initParallax(){
    if(reduceMotion || (window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) return;

    var mm = window.matchMedia('(min-width: 750px)');
    var state = { ticking:false, width:window.innerWidth, height:window.innerHeight };
    var hero = document.querySelector('.jr-hero');

    var motionSelectors = [
      '.jr-og-property',
      '.jr-section-head',
      '.jr-stats__head',
      '.jr-og-listings__head',
      '.jr-service-card',
      '.jr-neighbourhood-card',
      '.jr-office-card',
      '.jr-press-item',
      '.jr-testimonial-stage',
      '.jr-social-bar',
      '.jr-contact',
      '.jr-stat'
    ].join(',');

    var imageSelectors = [
      '.jr-about__media img',
      '.jr-split__media img',
      '.jr-press-feature__media img',
      '.jr-philanthropy__media img',
      '.jr-app-cta__media img',
      '.jr-concierge__after img',
      '.jr-concierge__before img',
      '.jr-og-property__media img'
    ].join(',');

    var motionNodes = Array.prototype.slice.call(document.querySelectorAll(motionSelectors));
    var imageNodes = Array.prototype.slice.call(document.querySelectorAll(imageSelectors));

    if(!hero && !motionNodes.length && !imageNodes.length) return;
    document.documentElement.classList.add('js-jr-scroll-motion');

    function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }

    function viewportProgress(rect){
      return clamp((state.height - rect.top) / (state.height + rect.height), 0, 1);
    }

    function updateHero(){
      if(!hero) return;
      var rect = hero.getBoundingClientRect();
      if(rect.bottom < 0 || rect.top > state.height) return;
      var p = clamp(-rect.top / Math.max(1, rect.height), 0, 1);
      var mediaY = p * 72;
      var copyY = p * 34;
      hero.style.setProperty('--jr-parallax-media', mediaY.toFixed(2) + 'px');
      hero.style.setProperty('--jr-parallax-copy', copyY.toFixed(2) + 'px');
    }

    function updateImages(){
      imageNodes.forEach(function(img){
        var rect = img.getBoundingClientRect();
        if(rect.bottom < -80 || rect.top > state.height + 80) return;
        var p = viewportProgress(rect) - .5;
        var amount = mm.matches ? 42 : 14;
        img.style.setProperty('--jr-img-parallax', (-p * amount).toFixed(2) + 'px');
      });
    }

    function updateNodes(){
      motionNodes.forEach(function(el, index){
        var rect = el.getBoundingClientRect();
        if(rect.bottom < -80 || rect.top > state.height + 80) return;
        var p = viewportProgress(rect) - .5;
        var speed = Number(el.dataset.jrMotionSpeed || 1);
        var stagger = (index % 6) * 1.8;

        if(el.classList.contains('jr-og-property')){
          var propertySpeed = 18 + (index % 3) * 6;
          el.style.setProperty('--jr-card-parallax', (-p * propertySpeed * speed + stagger).toFixed(2) + 'px');
        } else if(el.classList.contains('jr-stat')){
          el.style.setProperty('--jr-stat-y', (-p * 16 * speed + stagger).toFixed(2) + 'px');
        } else if(el.classList.contains('jr-section-head') || el.classList.contains('jr-stats__head') || el.classList.contains('jr-og-listings__head')){
          el.style.setProperty('--jr-heading-parallax', (-p * 22 * speed).toFixed(2) + 'px');
        } else {
          el.style.setProperty('--jr-editorial-y', (-p * 20 * speed + stagger).toFixed(2) + 'px');
        }
      });
    }

    function update(){
      updateHero();
      updateImages();
      updateNodes();
      state.ticking = false;
    }

    function requestTick(){
      if(!state.ticking){
        state.ticking = true;
        requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', requestTick, {passive:true});
    window.addEventListener('resize', function(){
      state.width = window.innerWidth;
      state.height = window.innerHeight;
      requestTick();
    });
    requestTick();
  }

  function boot(){
    initStaggerIndexes();
    initReveal();
    initHero();
    initTestimonials();
    initConcierge();
    initCountUp();
    initProgress();
    initMagneticButtons();
    initParallax();
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();


/* JR GLOBAL HOMEPAGE SOCIAL RAIL ADAPTIVE */
(function(){
  function parseRGB(value){
    if(!value || value === 'transparent' || value === 'rgba(0, 0, 0, 0)') return null;
    var match = value.match(/rgba?\(([^)]+)\)/i);
    if(!match) return null;
    var parts = match[1].split(',').map(function(part){return parseFloat(part.trim());});
    if(parts.length >= 4 && parts[3] === 0) return null;
    return {r:parts[0]||0,g:parts[1]||0,b:parts[2]||0};
  }
  function luminance(rgb){
    return (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b);
  }
  function isVisuallyDark(el){
    var node = el;
    while(node && node !== document.documentElement){
      var cs = window.getComputedStyle(node);
      var bg = parseRGB(cs.backgroundColor);
      if(bg) return luminance(bg) < 138;
      var bgImage = cs.backgroundImage || '';
      if(bgImage && bgImage !== 'none'){
        if(/linear-gradient|radial-gradient/i.test(bgImage) && /(0, 0, 0|#000|rgba\(0|rgb\(0|207, 18, 53|12, 11, 10)/i.test(bgImage)) return true;
      }
      node = node.parentElement;
    }
    return true;
  }
  function updateRail(){
    var rail = document.querySelector('[data-jr-home-social-rail]');
    if(!rail) return;
    var rect = rail.getBoundingClientRect();
    var x = Math.max(1, Math.min(window.innerWidth - 1, rect.left + 10));
    var y = Math.max(1, Math.min(window.innerHeight - 1, rect.top + rect.height / 2));
    var hidden = rail.style.pointerEvents;
    rail.style.pointerEvents = 'none';
    var below = document.elementFromPoint(x, y);
    rail.style.pointerEvents = hidden || '';
    var dark = below ? isVisuallyDark(below) : true;
    rail.classList.toggle('jr-home-social-rail--light', dark);
    rail.classList.toggle('jr-home-social-rail--dark', !dark);
  }
  function initRail(){
    var rail = document.querySelector('[data-jr-home-social-rail]');
    if(!rail) return;
    updateRail();
    var ticking = false;
    function requestUpdate(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(function(){ ticking = false; updateRail(); });
    }
    window.addEventListener('scroll', requestUpdate, {passive:true});
    window.addEventListener('resize', requestUpdate, {passive:true});
    document.addEventListener('shopify:section:load', requestUpdate);
    setTimeout(updateRail, 300);
    setTimeout(updateRail, 1200);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRail);
  else initRail();
})();
/* END JR GLOBAL HOMEPAGE SOCIAL RAIL ADAPTIVE */
